export default __webpack_public_path__ + "static/media/intro-scene-landscape.b4bc83ca.png";